import { useSyncExternalStore } from 'react'

/**
 * Files that failed to upload right after a ticket was created on the
 * full-page form (`/tickets/new`). Kept in memory for this tab only (the File
 * objects cannot be persisted), keyed by ticket id, so the ticket page can
 * offer a retry.
 */
export interface PendingUpload {
  file: File
  visibility: 'customer' | 'internal'
  error: string
}

const store = new Map<string, PendingUpload[]>()
const listeners = new Set<() => void>()
const EMPTY: PendingUpload[] = []

function emit() {
  for (const l of listeners) l()
}

export const pendingUploads = {
  set(ticketId: string, uploads: PendingUpload[]) {
    if (uploads.length) store.set(ticketId, uploads)
    else store.delete(ticketId)
    emit()
  },
  get(ticketId: string): PendingUpload[] {
    return store.get(ticketId) ?? EMPTY
  },
  subscribe(listener: () => void) {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
}

export function usePendingUploads(ticketId: string): PendingUpload[] {
  return useSyncExternalStore(pendingUploads.subscribe, () => pendingUploads.get(ticketId))
}
